import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import {read} from "../../pages/view-post/api.js";
import Post from "../../pages/view-post/Post.jsx";

export default function CreatePost(){

    
    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
   

    useEffect(() => {
        fetchPosts();
    }, [skip]);


    const fetchPosts = async () => {
        try{
            const { data, error } = await read(skip);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }

            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        }
    }

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }
    return <Grid container className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                <Grid item xl={1.5} lg={1.9} md={2.6} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid item xl={10.5} lg={10.1} md={9.4} sm={8.8}>
                    <Grid className="boxshadowclass">
                        <Header></Header>
                    </Grid>
                    <Grid>
                        <div>
                            {posts?.map((post) => (
                                <Post key={post._id} {...post}/>
                            ))}
                            
                        </div>
                        {isEnd}
                    </Grid>
                </Grid>    
            </Grid>
    };